import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { AddressBookModalContainer } from './AddressBookModalContainer.js';

const AddressBookModal = (props)=>/*#__PURE__*/ React.createElement(AddressBookModalContainer, swcHelpers.extends({}, props))
;

export { AddressBookModal };
//# sourceMappingURL=Layout.js.map
